<div class="topDiv" [style.background-color]="backgroundColorScreen">
    <div class="agGridOuterDiv" style="margin-top:3%">
        <div class="vaultDataloadHeadDiv">
            <h4>Database to Vault Migration</h4>
        </div>
    </div>

    <div class="container" style="display: flex;text-align: center;margin-top: 15px;">
        <div style="width: 49%;display: inline-block;justify-content: space-evenly; text-align: left;padding: 25px;border: 1px solid darkgray;">
            <label style="font-weight: 500;
            font-size: large;text-align: left;">Start Migration</label>

            <div style="display: flex;justify-content: space-around;">

                <button i18n="@@TMRunButton" type="button" (click)="start()"
                style="border: 2px solid; color: black; justify-content: flex-start;"
                class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.border-color]="backgroundColorButton">Start</button>

                <button i18n="@@TMRunButton" type="button" (click)="abort()"
                    style="border: 2px solid; color: black; justify-content: flex-end;"
                    class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.border-color]="backgroundColorButton">Abort</button>

            </div>
            <div class="keyValueCss" style="text-align: left; padding-top: 10px;">
                <span class="keyCss">Migration Id</span>
                <span class="colonCss">:</span>
                <span class="valueCss">{{mgrid}}</span>

            </div>
            <div class="keyValueCss" style="text-align: left; padding-top: 10px;">
                <span class="keyCss">Start Date & Time</span>
                <span class="colonCss">:</span>

                <span class="valueCss">{{mgrstartdt}}</span>
            </div>
            <div class="keyValueCss" style="text-align: left;">
                <span class="keyCss">Status</span>
                <span class="colonCss">:</span>

                <span class="valueCss">{{mgrstatus}}</span>
            </div>
        </div>
        <div style="margin:auto;display:inline-block;width: 2%;">

            <div style="font-size: xx-large">

          

            </div>

        </div>
            <div style="width: 49%;display: inline-block;text-align: left;padding: 25px;border: 1px solid darkgray;">
                <label style="font-weight: 500;
                font-size: large;">Attach Mapping File</label>
                <div style="display: flex;">
                <label style="padding-bottom: 30px;font-weight: 500;
                font-size: medium;padding-top: 8px;width:25%">Mapping File:</label>
                <form  novalidate [formGroup]='FormValid'>
                <div style="display: flex;">
                <mat-form-field appearance="outline" style="width: 55%;">
                    <mat-label i18n="@@TMshoppingcomplexchooseimage">Choose File</mat-label>
                    <input matInput class="file-path validate" type="text" maxlength="250" placeholder="Choose File" formControlName="imageName" id="imageName" [(ngModel)]="statevaluechange.fileName" readonly required>
                    <mat-error *ngFor="let validation of validation_messages.imageName">
                    <span
                      *ngIf="FormValid.get('imageName').hasError(validation.type) && (FormValid.get('imageName').dirty || FormValid.get('imageName').touched)">
                      {{ validation.message }}
                    </span>
                  </mat-error>
                </mat-form-field>

                <div class="file-field" style="width: 20%;margin-right: 10px;">
                    <a class="btn-floating  btn-sm ml-4 m-0">
                        <em class="fas fa-paperclip mt-0" style="text-rendering: auto;color:black"></em>
                        <input type="file" id="imageupload" name="imageupload" (change)="mappingFiletoS3($event,'csv')" formControlName="imageupload">
                    </a>
                </div>
                <div style="text-align: center;">

                    <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Upload" (click)="uploadFile()">Upload
                        <em style="padding: 0px 0px 0px 10px;" class="fas fa-upload example-icon" title="Upload"></em>
                    </button>

           
        </div>
            </div>
        </form>
    </div>
    <div>
        <label style="font-weight: 500;
        font-size: medium;">Uploaded Mapping File:</label>
        <div (click)="downloadmappingfile()" style="    color: cornflowerblue;
        text-decoration: underline;">
             {{MappingFile | slice:27}}

        </div>
    </div>
    </div>
            <div style="margin:auto;display:inline-block">

                <div style="font-size: xx-large">

                  

                </div>

            </div>

    </div>

    <div class="container" style="border-bottom: 0.01px ridge coral; margin-top: 1em;"></div>



    <div class="container" style="    display: flex;
    text-align: center;margin-top: 15px;">
        <div style="width: 30%;display: inline-block;text-align: center;padding: 25px;border: 1px solid darkgray;">
            <label style="padding-bottom: 35px;font-weight: 500;
            font-size: large;">Extract Source Data</label>
            <div>
                   <button i18n="@@TMRunButton" type="button" (click)="onExtration()" [style.background-color]="backgroundColorButton"
                   class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 2.9rem;" [disabled]="!loaderTrace ||!migrationTrace" [style.border-color]="backgroundColorButton">Extract</button>
                </div>
            </div>
            <div style="margin:auto;display:inline-block">

                <div style="font-size: xx-large">

                    <em class="fas fa-arrow-alt-circle-right"></em>

                </div>

            </div>
            <div style="width: 30%;display: inline-block;text-align: center;padding: 25px;border: 1px solid darkgray;">
                <label style="    padding-bottom: 35px;font-weight: 500;
                font-size: large;">Transform Source Data</label>
                <div>
                    <button i18n="@@TMRunButton" type="button" (click)="onTransformation()" [style.background-color]="backgroundColorButton"
                    class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;" [disabled]="!migrationTrace" [style.border-color]="backgroundColorButton">Transformation</button>
                 </div>
                </div>
                <div style="margin:auto;display:inline-block">

                    <div style="font-size: xx-large">

                        <em class="fas fa-arrow-alt-circle-right"></em>

                    </div>

                </div>
                <div style="width: 30%;display: inline-block;text-align: center;padding: 25px;border: 1px solid darkgray;">
                    <label style="    padding-bottom: 35px;font-weight: 500;
                    font-size: large;">Load to Vault Transformed Data</label>
                    <div>
                    <button i18n="@@TMRunButton" type="button" (click)="onLoading()" [style.background-color]="backgroundColorButton"
                                class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;" [disabled]="!transformTrace" [style.border-color]="backgroundColorButton">Load to Vault</button>
                 </div>
                </div>
    </div>
    <div>
        <div  [style.background-color]="backgroundColorScreen">

            <div class="agGridOuterDiv">
                <div>

                    <mat-toolbar class="agGridtoperDiv card" style="background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8; border-right: 1px solid #a9a9a9a8; border-left: 1px solid #a9a9a9a8;">

                        <mat-form-field appearance="outline" style="    margin-top: 22px;
                        font-size: small;
                        font-weight: 500;width:200px;">
                            <mat-select [ngModelOptions]="{standalone:true}"  [(ngModel)]="eachetlName" (ngModelChange)="selectedprocess($event)">
                                    <mat-option style="font-size: 15px;" *ngFor="let eachetl of etlProcess" [value]="eachetl.value">

                                        {{eachetl.name}}
                                    </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <span class="example-spacer"></span>
            
                        <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Refresh" (click) = "refresh()">
                            Refresh<em style="padding: 0px 0px 0px 10px;" class="fas fa-refresh" title="Refresh"></em>
                        </button>
                        <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Download" (click) = "onBtExport()">
                            Download<em style="padding: 0px 0px 0px 10px;" class="fas fa-download example-icon" title="Download"></em>
                        </button>
                        <div class="insertPageNoDiv">
                            <mat-form-field appearance="outline">
                                <mat-label i18n="@@Targetpageno">Page No</mat-label>
                                <input matInput type="text" (input)="onSearchChange($event.target.value)">
                            </mat-form-field>
                        </div>
                        <div class="selectRecordsDiv" style="width:9.5%">
                            <mat-form-field appearance="outline" style="width:100%">
                                <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
                                <mat-select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChanged(value)">
                                    <mat-option value="10" selected>10</mat-option>
                                    <mat-option value="200">200</mat-option>
                                    <mat-option value="300">300</mat-option>
                                    <mat-option value="400">400</mat-option>
                                </mat-select>

                            </mat-form-field>
                        </div>
                        <div class="card pagination paginationFirstButton paginationFirstlastButton">
                            <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
                        </div>
                        <div class="card pagination paginationButtons btn-rounded">
                            <ul>
                                <li class="paginationliicon">
                                    <em class="fas fa-angle-left waves-effect waves-light" (click)="onBtPrevious()"></em>
                                </li>
                                <li>{{currentPage}}/{{totalPages}}</li>
                                <li class="paginationliicon" style="padding:0;">
                                    <em class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em>
                                </li>
                            </ul>
                        </div>
                        <div class="card pagination paginationLastButton paginationFirstlastButton">
                            <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
                        </div>

                    </mat-toolbar>
                </div>
                <div *ngIf='migrationTrace'>

                    <ag-grid-angular style="height: 400px;" class="ag-theme-balham table-width-tabs tablestyles square scroolbar-dusty-grass square thin" [columnDefs]="columnDefsExtract" [animateRows]="true"  [pagination]="true" [rowSelection]="rowSelection" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true"  [floatingFiltersHeight]="45"[paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter" [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules" (paginationChanged)="onPaginationChanged()" [components]="components" (gridReady)="onGridReady($event)" [hidden]="!true"></ag-grid-angular>

                </div>

                <div *ngIf='transformTrace'>

                    <ag-grid-angular style="height: 400px;" class="ag-theme-balham table-width-tabs tablestyles square scroolbar-dusty-grass square thin" [columnDefs]="columnDefs" [animateRows]="true"  [pagination]="true" [rowSelection]="rowSelection" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"[paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter" [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules" (paginationChanged)="onPaginationChanged()" [components]="components"        (gridReady)="onGridReadyTransform($event)" [hidden]="!true"></ag-grid-angular>

                </div>

                <div *ngIf="loaderTrace">
                    <ag-grid-angular style="height: 400px;" class="ag-theme-balham table-width-tabs tablestyles square scroolbar-dusty-grass square thin" [columnDefs]="columnDefsLoader" [animateRows]="true"  [pagination]="true" [rowSelection]="rowSelection" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"[paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter" [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules" (paginationChanged)="onPaginationChanged()" [components]="components"        (gridReady)="onGridReadyLoader($event)" [hidden]="!true">
                    </ag-grid-angular>
                </div>

                <div *ngIf="loaderTrace">
                    <div>

                        <mat-toolbar class="agGridtoperDiv card" style="background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8; border-right: 1px solid #a9a9a9a8; border-left: 1px solid #a9a9a9a8;">
                            <span class="example-spacer"></span>
                            <div class="insertPageNoDiv">
                                <mat-form-field appearance="outline">
                                    <mat-label i18n="@@Targetpageno">Page No</mat-label>
                                    <input matInput type="text" (input)="onSearchChangevalidation($event.target.value)">
                                </mat-form-field>
                            </div>
                            <div class="selectRecordsDiv" style="width:9.5%">
                                <mat-form-field appearance="outline" style="width:100%">
                                    <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
                                    <mat-select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChangedvalidation(value)">
                                        <mat-option value="10" selected>10</mat-option>
                                        <mat-option value="200">200</mat-option>
                                        <mat-option value="300">300</mat-option>
                                        <mat-option value="400">400</mat-option>
                                    </mat-select>

                                </mat-form-field>
                            </div>
                            <div class="card pagination paginationFirstButton paginationFirstlastButton">
                                <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirstvalidation()"></em>
                            </div>
                            <div class="card pagination paginationButtons btn-rounded">
                                <ul>
                                    <li class="paginationliicon">
                                        <em class="fas fa-angle-left waves-effect waves-light" (click)="onBtPreviousvalidation()"></em>
                                    </li>
                                    <li>{{currentPageValidation}}/{{totalPagesValidation}}</li>
                                    <li class="paginationliicon" style="padding:0;">
                                        <em class="fas fa-angle-right waves-effect waves-light" (click)="onBtNextvalidation()"></em>
                                    </li>
                                </ul>
                            </div>
                            <div class="card pagination paginationLastButton paginationFirstlastButton">
                                <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLastvalidation()"></em>
                            </div>

                        </mat-toolbar>
                    </div>
                    <ag-grid-angular style="height: 400px;" class="ag-theme-balham table-width-tabs tablestyles square scroolbar-dusty-grass square thin" [columnDefs]="columnDefsvaultvalidation" [animateRows]="true"  [pagination]="false" [rowSelection]="rowSelection" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"[paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter" [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules" (paginationChanged)="onPaginationChanged()" [components]="components" (gridReady)="onGridReadyVaultValidation($event)" [hidden]="!true">
                    </ag-grid-angular>


                </div>

            </div>
        </div>

    </div>
</div>
